import { crudGetOne, CrudGetOneAction, Identifier } from "ra-core";

export const crudGetOneEx = (
  resource: string,
  id: Identifier,
  basePath: string,
  onFailureEx: any = {}
): CrudGetOneAction => {
  const x = crudGetOne(resource, id, basePath)
  return {...x,
    ...(onFailureEx && ({ 
      meta: {
        ...x.meta,
        onFailure: onFailureEx,
      }
    }))
  }
};

